module.exports = __webpack_public_path__ + "img/89.cf63d55f.jpg";